import { AuthenticatedUser } from "../../../../../../../shared/types";
import * as Features from '../../../../../../../shared/Features';
import * as PhotoStatus from '../../../../../../../shared/PhotoStatus';

var DOWNLOAD_EDITED_STATUSES = [
    PhotoStatus.CustomerApproved,
    PhotoStatus.Delivered,
    PhotoStatus.DeliveryError,
    PhotoStatus.DeliveryStarted,
    PhotoStatus.SetToRedeliver
];


export function canUserDownload(
    user: AuthenticatedUser,
    photoStatus: number,
    numberOfDeliverableImages: number
): boolean {
    var canDownloadEdited =
        Features.hasFeature(Features.DownloadEditedImages, user) &&
        DOWNLOAD_EDITED_STATUSES.indexOf(photoStatus) !== -1;

    var hasDownloadPermission =
        canDownloadEdited || Features.hasFeature(Features.DownloadImages, user);

    return hasDownloadPermission && numberOfDeliverableImages > 0;
}
